import { useEffect, useRef, useState } from "react";
import { Type, Contrast, Volume2, Square } from "lucide-react";

const SPEAK_TEXT =
  "Ye muy fácil. Traducimos textos difíciles a lectura fácil, para que todas las personas puedan entenderlos. " +
  "Cada texto se valida con personas del CAI de Pando, en Langreo. " +
  "Escríbenos a info punto bilbaobianco punto com, o llama al seis, dos, tres, cuatro, cero, nueve, cuatro, uno, seis.";

const LEVELS = [
  { key: "n", label: "Normal" },
  { key: "lg", label: "Grande" },
  { key: "xl", label: "Muy grande" },
];

export default function AccessibilityDock() {
  const [level, setLevel] = useState(0);
  const [hc, setHc] = useState(false);
  const [speaking, setSpeaking] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      window.speechSynthesis?.cancel();
    };
  }, []);

  useEffect(() => {
    document.documentElement.dataset.fs = LEVELS[level].key;
  }, [level]);

  useEffect(() => {
    document.documentElement.classList.toggle("hc", hc);
  }, [hc]);

  const speak = () => {
    if (speaking) {
      window.speechSynthesis.cancel();
      setSpeaking(false);
      return;
    }
    const u = new SpeechSynthesisUtterance(SPEAK_TEXT);
    u.lang = "es-ES";
    u.rate = 0.95;
    u.onend = () => mounted.current && setSpeaking(false);
    u.onerror = () => mounted.current && setSpeaking(false);
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
    setSpeaking(true);
  };

  const btn = "flex items-center gap-2 px-3 py-2 text-sm font-bold hover:bg-[var(--yellow)] transition-colors";

  return (
    <div
      className="fixed bottom-4 left-4 z-50 flex items-center sketch bg-[var(--card)] px-1.5 py-1 shadow-[4px_4px_0_var(--ink)]"
      data-testid="accessibility-dock"
      role="toolbar"
      aria-label="Herramientas de accesibilidad"
    >
      <button className={btn} data-testid="dock-font-size" onClick={() => setLevel((level + 1) % LEVELS.length)} title="Tamaño del texto" aria-label="Cambiar tamaño del texto">
        <Type className="w-5 h-5 shrink-0" aria-hidden="true" />
        <span className="hidden sm:inline">{LEVELS[level].label}</span>
      </button>
      <button className={btn} data-testid="dock-contrast" onClick={() => setHc(!hc)} title="Modo de alto contraste" aria-label="Activar o desactivar el modo de alto contraste" aria-pressed={hc}>
        <Contrast className="w-5 h-5 shrink-0" aria-hidden="true" />
        <span className="hidden sm:inline">{hc ? "Contraste alto" : "Contraste"}</span>
      </button>
      <button className={btn} data-testid="dock-speak" onClick={speak} title="Escuchar un resumen en voz alta" aria-label="Escuchar un resumen de la página en voz alta" aria-pressed={speaking}>
        {speaking ? <Square className="w-5 h-5 shrink-0" aria-hidden="true" /> : <Volume2 className="w-5 h-5 shrink-0" aria-hidden="true" />}
        <span className="hidden sm:inline">{speaking ? "Parar" : "Escuchar"}</span>
      </button>
    </div>
  );
}
